var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { css, keyframes, styled } from '@creditas-ui/system';
import { getTypography, ifProp, selectTheme, variant } from '@creditas-ui/utilities';
import { Inlinelink as DefaultInlineLink } from '@creditas-ui/inline-link';
var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: 'Nunito Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-weight: 700;\n  border-radius: 3em;\n  display: inline-block;\n  line-height: 1;\n  box-sizing: border-box;\n"])));

var enterAnimation = factor => keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n0% {transform: translate3d(0,", "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n"])), factor * -200);

var exitAnimation = factor => keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0,", "%,-1px) scale(.6); opacity:0;}\n"])), factor * -150);

var inlineLinkStyles = _ref => {
  var {
    theme: {
      toast
    }
  } = _ref;
  return variant({
    variants: {
      light: {
        color: toast('light.text.color')
      },
      dark: {
        color: toast('dark.text.color')
      }
    }
  });
};

var InlineLink = styled(DefaultInlineLink)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), inlineLinkStyles);

var containerStyles = _ref2 => {
  var {
    theme: {
      toast
    }
  } = _ref2;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 355px;\n  max-width: min(355px, 100%);\n  min-height: 80px;\n  border: none;\n  border-radius: ", ";\n  box-shadow: ", ";\n  ", ";\n"])), toast('base.container.borderRadius'), toast('base.container.shadow'), toast('base.container.padding'));
};

var containerVariantStyles = _ref3 => {
  var {
    theme: {
      toast
    }
  } = _ref3;
  return variant({
    variants: {
      light: {
        backgroundColor: toast('light.container.backgroundColor')
      },
      dark: {
        backgroundColor: toast('dark.container.backgroundColor')
      }
    }
  });
};

var HorizontalSpace = styled(Box)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin: 0 calc(", " / 2);\n"])), selectTheme('spacingX.6xl'));
var ToastElement = styled(Box.withComponent('button', process.env.NODE_ENV === "production" ? {
  target: "e1f022790"
} : {
  target: "e1f022790",
  label: "ToastElement"
}))(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: ", ";\n  animation: ", ";\n"])), base, containerVariantStyles, containerStyles, ifProp({
  as: 'button'
}, 'pointer', 'initial'), ifProp({
  isVisible: false
}, css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      ", "\n      0.4s forwards cubic-bezier(0.06, 0.71, 0.55, 1)\n    "])), exitAnimation(0)), css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      ", "\n      0.35s cubic-bezier(0.21, 1.02, 0.73, 1) forwards\n    "])), enterAnimation(0))));
var ToastStringChildren = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e1f022791"
} : {
  target: "e1f022791",
  label: "ToastStringChildren"
}))(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  flex: 1;\n  color: ", ";\n  text-align: left;\n  align-self: center;\n  white-space: pre-wrap;\n  ", ";\n"])), ifProp({
  variant: 'dark'
}, selectTheme('colors.neutral.0'), selectTheme('colors.neutral.90')), getTypography('bodySmRegular'));
export { ToastElement, ToastStringChildren, InlineLink, HorizontalSpace };
//# sourceMappingURL=Toast.style.js.map